/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsCart = {
  init: function ($section) {

    // Add settings from schema to current object
    //window.PXUTheme.jsCart = $.extend(this, window.PXUTheme.getSectionData($section));

    this.$section = $section;

    $(document).on('click', '[data-cart-page-delete]', function (e) {
      e.preventDefault();




      /* Mounting Option Code BEGIN: linked removal logic for mounting/main */
      const $btn = $(this);
      const $card = $btn.closest('.cart__card');
      const belongsToKey = $card.attr('data-belongs-to-key');
      const itemKey = $btn.attr('data-cart-item-key');

      if (belongsToKey && itemKey) {
        // Removing a mounting option: also remove its parent product
        window.PXUTheme.jsCart.removeMountAndParent(itemKey, belongsToKey);
      } else {
        // Possibly removing a main product; if it has mounting children, remove them too
        const parentKey = $card.attr('data-cart-item');
        const $children = window.PXUTheme.jsCart.$section.find(`.mounting_option_card[data-belongs-to-key="${parentKey}"]`);
        if ($children.length > 0 && parentKey) {
          window.PXUTheme.jsCart.removeParentAndChildren(parentKey);
        } else {
          const lineID = $btn.data('line-item-key');
          window.PXUTheme.jsCart.removeFromCart(lineID);
        }
      }
      /* Mounting Option Code END: linked removal logic for mounting/main */





      return false;
    });

    // Prevent the ajax cart form from being submitted when pressing the "Enter" key
    $('#cart_form').keydown(function(e){
      if (e.keyCode == 13) {
        e.preventDefault();
        return false;
      }
    });
  },



  /* Mounting Option Code BEGIN: helper to remove by line item key */
  removeByKey: function(itemKey) {
    const $cartItem = window.PXUTheme.jsCart.$section.find(`[data-cart-item="${itemKey}"]`);
    $cartItem.css('opacity', '0.5');
    return $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&id=' + encodeURIComponent(itemKey),
      dataType: 'json'
    });
  },
  // When a mounting option is removed, also remove its parent product (and any sibling mountings)
  removeMountAndParent: function(childKey, parentKey) {
    const $section = window.PXUTheme.jsCart.$section;
    const $childCards = $section.find(`.mounting_option_card[data-belongs-to-key="${parentKey}"]`);
    // Collect all child keys for this parent
    const childKeys = $childCards.map(function(){ return $(this).attr('data-cart-item'); }).get();

    // Visually dim all affected cards (children + parent)
    $childCards.css('opacity', '0.5');
    const $parent = $section.find(`[data-cart-item="${parentKey}"]`);
    $parent.css('opacity', '0.5');

    const removeByKeyAjax = function(key) {
      return $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=0&id=' + encodeURIComponent(key),
        dataType: 'json'
      });
    };

    // Remove children sequentially, then parent
    const removeChildrenSeq = (keys) => keys.reduce((p, key) => p.then(() => removeByKeyAjax(key)), Promise.resolve());

    removeChildrenSeq(childKeys)
      .then(() => removeByKeyAjax(parentKey))
      .then((cart) => {
        // Animate and remove from DOM
        $childCards.addClass('animated zoomOut');
        $parent.addClass('animated zoomOut');
        $childCards.remove();
        $parent.remove();

        window.PXUTheme.jsCart.updateView(cart, null);

        if (typeof window.PXUTheme.jsAjaxCart !== 'undefined') {
          window.PXUTheme.jsAjaxCart.updateView();
        }
      })
      .catch(() => {
        // Fallback: reload to keep UI/cart in sync
        window.location.href = '/cart';
      });
  },
  removeParentAndChildren: function(parentKey) {
    const $section = window.PXUTheme.jsCart.$section;
    const $childCards = $section.find(`.mounting_option_card[data-belongs-to-key="${parentKey}"]`);
    const childKeys = $childCards.map(function(){ return $(this).attr('data-cart-item'); }).get();

    // Dim affected items
    $childCards.css('opacity', '0.5');
    const $parent = $section.find(`[data-cart-item="${parentKey}"]`);
    $parent.css('opacity', '0.5');

    const removeByKeyAjax = function(key) {
      return $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=0&id=' + encodeURIComponent(key),
        dataType: 'json'
      });
    };

    const removeChildrenSeq = (keys) => keys.reduce((p, key) => p.then(() => removeByKeyAjax(key)), Promise.resolve());

    removeChildrenSeq(childKeys)
      .then(() => removeByKeyAjax(parentKey))
      .then((cart) => {
        $childCards.addClass('animated zoomOut');
        $parent.addClass('animated zoomOut');
        $childCards.remove();
        $parent.remove();

        window.PXUTheme.jsCart.updateView(cart, null);
        if (typeof window.PXUTheme.jsAjaxCart !== 'undefined') {
          window.PXUTheme.jsAjaxCart.updateView();
        }
      })
      .catch(() => {
        window.location.href = '/cart';
      });
  },
  /* Mounting Option Code END: remove parent and its mounting children */





  removeFromCart: function (lineID) {
    const $cartItem = window.PXUTheme.jsCart.$section.find(`[data-line-item="${lineID}"]`);

    $cartItem.css('opacity', '0.5');

    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line=' + lineID,
      dataType: 'json',
      success: function (cart) {

        $cartItem.addClass('animated zoomOut')
        $cartItem.remove();

        window.PXUTheme.jsCart.updateView(cart, lineID);

        if (typeof window.PXUTheme.jsAjaxCart !== 'undefined') {
          window.PXUTheme.jsAjaxCart.updateView();
        }
      },
      error: function (XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
      }
    });
  },
  updateView: function (cart, lineID) {

    if (cart.item_count > 0) {
      $.ajax({
        dataType: "json",
        async: false,
        cache: false,
        dataType: 'html',
        url: "/cart",
        success: function (html) {




          /* Mounting Option Code BEGIN: reconcile cart list length and reindex after multi-removals */
          const updatedItems = $(html).find('.cart__item-list .cart__card');
          let currentItems = $('.cart__item-list .cart__card');

          if (updatedItems.length != currentItems.length){
            const updatedCartList = $(html).find('.cart__item-list');
            $('.cart__item-list').replaceWith(updatedCartList);
            currentItems = $('.cart__item-list .cart__card');
          }

          $(currentItems).each(function(index, element){
            const newIndex = (index + 1);
            $(element).attr('data-line-item', newIndex);
            $(element).find('[data-line-item-key]').attr('data-line-item-key', newIndex);
            const $remove = $(element).find('[data-cart-page-delete]');
            const href = $remove.attr('href');
            if (href && href.indexOf('line=') !== -1) {
              const newHref = href.replace(/line=\d+/, 'line=' + newIndex);
              $remove.attr('href', newHref);
            }
          });
          /* Mounting Option Code END: reconcile cart list length and reindex after multi-removals */




          
          if (lineID !== null) {
            const itemTotal = $(html).find(`[data-line-item="${lineID}"]`).find('.cart__total');
            const quantityInput = $(html).find(`[data-line-item="${lineID}"]`).find('.quantity-input');
            const itemPrice = $(html).find(`[data-line-item="${lineID}"]`).find('.cart__price');

            $(`[data-line-item="${lineID}"]`).find('.cart__total').replaceWith(itemTotal);
            $(`[data-line-item="${lineID}"]`).find('.quantity-input').replaceWith(quantityInput);
            $(`[data-line-item="${lineID}"]`).find('.cart__price').replaceWith(itemPrice);
          }

          const subtotal = $(html).find('.cart__subtotal-container');
          const discounts = $(html).find('.cart__discounts');
          const savings = $(html).find('.cart__total-savings');

          $('.cart__subtotal-container').replaceWith(subtotal);

          if (discounts.length > 0 && $('.cart__discounts').length < 1) {
            $('.cart__subtotal-container').before(discounts);
          } else {
            $('.cart__discounts').replaceWith(discounts);
          }

          if (savings.length > 0 && $('.cart__total-savings').length < 1) {
            $('.cart__subtotal-container').after(savings);
          } else {
            $('.cart__total-savings').replaceWith(savings);
          }

          $('[data-bind="itemCount"]').text(cart.item_count);

        }
      });

    } else {
      $('.cart__empty-cart-message').removeClass('is-hidden');
      $('.cart__form').addClass('is-hidden');
      $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
      $('[data-bind="itemCount"]').text('0');
    }

  },
  unload: function ($section) {
    // Clear event listeners in theme editor
    $('[data-cart-page-delete]').off();
    $('#cart_form').off();
  }
}

/******/ })()
;